/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface avatarNoGenderProps extends React.SVGAttributes<SVGElement> {
size?: string | number;
}
const avatarNoGender: React.FC<avatarNoGenderProps> = ({size, ...props}) => (
  <svg viewBox="0 0 60 60" fill="currentColor" width={ size || "1em" } height={ size || "1em" } {...props}>
    <path d="M30,0H0V60H60V0ZM48.78,50.75a20,20,0,0,0-37.4.14,28,28,0,1,1,37.4-.14ZM44.63,3.8h0ZM13.26,5.1h0Zm-7.17,43,0,.05,0,0ZM53.88,11.85h0Zm-11.77,12a12,12,0,1,1-12-12A12,12,0,0,1,42.11,23.86Z"
    />
  </svg>
);
avatarNoGender.displayName = 'avatarNoGender';
export default avatarNoGender;
/* tslint:enable */
/* eslint-enable */
